// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedMessagesEmpty__info-block-ce94ea {
  max-width: 420px;
  min-width: 312px;
  color: var(--addition-50);
  background: var(--average-background);
}

.SavedMessagesEmpty__info-block-ce94ea .SavedMessagesEmpty__icon-d77765 {
  height: 176px;
}

.SavedMessagesEmpty__title-b0e6c4 {
  align-self: flex-start;
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  margin-bottom: var(--indent-16px);
  padding: 0 calc(6px + var(--indent-16px));
}

.SavedMessagesEmpty__list-e3a51a {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.SavedMessagesEmpty__list-item-a4d617 {
  display: flex;
  align-items: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body);
  margin-bottom: var(--indent-8px);
}

.SavedMessagesEmpty__bullet-d0b19c {
  background-color: var(--addition-50);
  border-radius: 100%;
  margin-inline-end: var(--indent-16px);
  width: 6px;
  min-width: 6px;
  height: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/MessagesEmpty/SavedMessagesEmpty/SavedMessagesEmpty.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,iCAAA;EACA,yCAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,wCAAA;EACA,gCAAA;AACF;;AAEA;EACE,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AACF","sourcesContent":[".info-block {\n  max-width: 420px;\n  min-width: 312px;\n  color: var(--addition-50);\n  background: var(--average-background);\n}\n\n.info-block .icon {\n  height: 176px;\n}\n\n.title {\n  align-self: flex-start;\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  margin-bottom: var(--indent-16px);\n  padding: 0 calc(6px + var(--indent-16px));\n}\n\n.list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.list-item {\n  display: flex;\n  align-items: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body);\n  margin-bottom: var(--indent-8px);\n}\n\n.bullet {\n  background-color: var(--addition-50);\n  border-radius: 100%;\n  margin-inline-end: var(--indent-16px);\n  width: 6px;\n  min-width: 6px;\n  height: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-block": `SavedMessagesEmpty__info-block-ce94ea`,
	"infoBlock": `SavedMessagesEmpty__info-block-ce94ea`,
	"icon": `SavedMessagesEmpty__icon-d77765`,
	"title": `SavedMessagesEmpty__title-b0e6c4`,
	"list": `SavedMessagesEmpty__list-e3a51a`,
	"list-item": `SavedMessagesEmpty__list-item-a4d617`,
	"listItem": `SavedMessagesEmpty__list-item-a4d617`,
	"bullet": `SavedMessagesEmpty__bullet-d0b19c`
};
module.exports = ___CSS_LOADER_EXPORT___;
